/**
 * Blue sequential intensity scale, indexed by level 0–4 (empty → most). Shared
 * by the heatmap cells and the Less→More legend so they never drift.
 */
export const LEVEL_CLASSES = [
  'bg-gray-100 dark:bg-gray-800',
  'bg-blue-100 dark:bg-blue-900/40',
  'bg-blue-200 dark:bg-blue-700/50',
  'bg-blue-400 dark:bg-blue-500/70',
  'bg-blue-600 dark:bg-blue-400',
];

export function computeThresholds(values: number[]): number[] {
  const sorted = values.filter(v => v > 0).sort((a, b) => a - b);
  if (sorted.length === 0) return [];
  const q = (f: number) => sorted[Math.min(Math.floor(sorted.length * f), sorted.length - 1)];
  return [q(0.25), q(0.5), q(0.75)];
}

export function getLevel(value: number, thresholds: number[]): number {
  if (value === 0) return 0;
  if (thresholds.length === 0) return 1;
  if (value <= thresholds[0]) return 1;
  if (value <= thresholds[1]) return 2;
  if (value <= thresholds[2]) return 3;
  return 4;
}
